// @ts-nocheck
import React from 'react'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'
import { colors } from '@lmc/common/constants'

const SearchSelect = (props) => {
  const SelectComponent = props.loadOptions ? AsyncSelect : Select
  return (
    <SelectComponent
      components={{ DropdownIndicator }}
      {...props}
      classNamePrefix="lmc-search-select"
      noOptionsMessage={NoOptionsMessage}
    />
  )
}

const NoOptionsMessage = ({ innerRef, innerProps }) => (
  <div
    className="lmc-search-select__dropdown-indicator"
    ref={innerRef}
    {...innerProps}
  >
    No search results
  </div>
)

const DropdownIndicator = ({ innerRef, innerProps }) => (
  <div
    className="lmc-search-select__dropdown-indicator"
    ref={innerRef}
    {...innerProps}
  >
    <div className="octicon octicon-search" style={styles.dropdownIndicator} />
  </div>
)

const styles = {
  dropdownIndicator: {
    color: colors.darkgrey,
    fontSize: 20,
    paddingRight: 10,
    transition: 'all .1s',
  },
}

export default SearchSelect
